import { css } from 'styled-components';

export const COLORS = {
  DARK_BLUE: '#434554',
  EMERALD_GREEN: '#4db3a4',
};

export const media = {
  handheld: (...args) => css`
    @media (max-width: 1024px) {
      ${css(...args)};
    }
  `,
};

export const redOrGreen = value => {
  return {
    color: value > 0 ? '#1bc700' : '#c70032',
  };
};
